export default "__VITE_ASSET__B7s45xxl__"